<template>
    <div :style="listHeight">
        <el-scrollbar style="height:100%;">
            <el-row v-for="(c,index) in summaryList" :key="index" style="margin-top: 3px;">
                <el-col :span="24">
                    <el-card :body-style="{ padding: '0px'}" shadow="hover">
                        <div style="padding: 14px;">
                            <div>
                                <span>{{c.CREATEUSERNAME}}对此任务进行了总结</span>
                                <div class="bottom clearfix">
                                    <table style="width:100%;">
                                        <tr>
                                            <td><time class="time">
    														时间：
    														{{timeFormat(c.CREATETIME)}}
    													</time></td>
                                            <td style="width:90px;line-height:30px">
                                                <el-button type="text" class="button" style="color:#6aca5d" @click="lookDetail(c.CREATEUSERID)">点击查看</el-button>
                                            </td>
                                        </tr>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </el-card>
                </el-col>
            </el-row>
        </el-scrollbar>
        
            <summaryTaskDialog  ref="summaryTaskDialog"></summaryTaskDialog>
    </div>
    
</template>

<script>
    import {
        Linq,
        DateFormat,
        TimeFormat
    } from '@/util/common'
    import {
        getAllTaskSummaryByTaskId
    } from "@/api/modules/basicData/task";
    import summaryTaskDialog from './summaryTaskDialog.vue';
    export default {
        components:{
            summaryTaskDialog
        },
        data() {
            return {
                summaryList: []
            }
        },
		created() {
			let a = $(window).height();
			this.listHeight = "height:" + (a - 150) + "px;";
		},
        methods: {
            initalTask: function() {
                if (!this.task || this.tabIndex !== '4') return;
                getAllTaskSummaryByTaskId(this.task.ID).then(pmevent => {
                    if (!pmevent) return;
                    this.summaryList = pmevent;
                });
            },
            timeFormat(time) {
				return TimeFormat(time);
            },
            lookDetail(userId) {
                // this.$refs.summaryTaskDialog.summaryTaskDialogVisible=true;
                this.$refs.summaryTaskDialog.lookDetail(userId);
            },
        },
        computed: {
            task: function() {
                return this.$store.state.task.curTask;
            },
            tabIndex: function() {
                return this.$store.state.task.tabIndex;
            },
        },
        watch: {
            task: function(newvalue) {
                if (!newvalue) return;
                this.initalTask();
            },
            tabIndex: function(newvalue) {
                if (!newvalue) return;
                this.initalTask();
            }
        }
    }
</script>

<style scoped>
    .button .el-button {
        background: #ecf5ff;
        color: #0099ff;
    }
    .button {
        margin: 20px 0 15px 20px;
        float: left;
    }
</style>